import React from 'react';

import { ButtonWithPreview } from 'common/components/TouchpointEditor/components/TouchpointNodes/Button';

export default function CustomButton(props) {
    return <ButtonWithPreview {...props} />;
}

CustomButton.splash = {
    ...ButtonWithPreview.splash,
    related: {
        ...ButtonWithPreview.splash.related,
        settings: React.lazy(() => import('./CustomButton.tools')),
    },
    defaultProps: {
        ...ButtonWithPreview.splash.defaultProps,
        meta: {
            ...ButtonWithPreview.splash.defaultProps.meta,
            content: 'Request a Demo',
            href: 'https://www.splashthat.com',
            visible: false,
            target: '_blank',
        },
    },
};
